import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayToString',
    standalone: false
})

export class ArrayToStringPipe implements PipeTransform {
  textValue: string;

  transform(value: any[], selectorName?: string): any {
    this.textValue = "";
    for (let i = 0; i < value.length; i++) {
      if (selectorName)
        this.textValue += (i == 0 ? "" : ", ") + value[i][selectorName];
      else
        this.textValue += (i == 0 ? "" : ", ") + value[i];
    }
    return this.textValue;
  }
}
